<nz-form-label *ngIf="labelText">
  {{ labelText }}
  <ng-container *ngIf="formGroup && fieldControlName">
    <ng-container
      *ngIf="
        fieldControlName
          | utils: 'checkIfFieldIsRequired':formGroup:formGroup.value
      "
    >
      <span class="label-suffix" nz-typography nzType="danger">*</span>
    </ng-container>
    <ng-container
      *ngIf="
        !(
          fieldControlName
          | utils: 'checkIfFieldIsRequired':formGroup:formGroup.value
        )
      "
    >
      <span class="label-suffix" nz-typography nzType="secondary">
        ({{ "FORM.LABEL.OPTIONAL" | translate }})
      </span>
    </ng-container>
  </ng-container>
</nz-form-label>
